import { useSupabaseClient } from "./useSupabaseClient.mjs";
import { useState } from "#imports";
export const useSupabaseSession = () => {
  const supabase = useSupabaseClient();
  const sessionState = useState("supabase_session", () => null);
  supabase?.auth.getSession().then(({ data: { session } }) => {
    if (session) {
      if (JSON.stringify(sessionState.value) !== JSON.stringify(session)) {
        sessionState.value = session;
      }
    } else {
      sessionState.value = null;
    }
  });
  return sessionState;
};
